<style lang="scss">
$--accent: rgb(255, 234, 0);
$--transition: all .25s ease-in-out;

button.tab-controls__item {
  appearance: none;
  background-color: transparent;
  border: none;
  outline: none;
}

.tab-controls {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  width: 100%;
  margin: 0;
  &__item {

    min-height: 48px;
    max-height: 48px;
    height: 48px;

    cursor: pointer;
    user-select: none;
    text-decoration: none;
    margin: 0 25px;
    padding: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    font-family: Inter;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    color: rgb(153, 153, 153);
    transition: $--transition;

    &__title {
      margin-top: 4px;
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }
    &__anchor {
      width: 0;
      min-height: 4px;
      max-height: 4px;
      height: 4px;
      border-radius: 2px;
      background-color: $--accent;
      transition: $--transition;
    }
    &:first-child {
      margin-left: 0;
    }

    &:hover,
    &.active,
    &.router-link-active {
      color: rgb(0, 0, 0);
    }
    &:hover &__anchor,
    &.active &__anchor,
    &.router-link-active &__anchor {
      width: 100%;
    }
  }
}
</style>

<template lang="pug">
section.visible__layout
  h1.h1-title {{$t('common.myOrders')}}

  spacer(size="40px")

  .tab-controls
    router-link.tab-controls__item(to="/tickets/actual")
      span.tab-controls__item__title {{ $t('common.actual') }}
      span.tab-controls__item__anchor
    router-link.tab-controls__item(to="/tickets/booked")
      span.tab-controls__item__title {{ $t('common.booked') }}
      span.tab-controls__item__anchor
    router-link.tab-controls__item(to="/tickets/used")
      span.tab-controls__item__title {{ $t('common.used') }}
      span.tab-controls__item__anchor
  //- arc-button(v-if="!isArena", :name="$t('common.assignTicket')", outline,
    @click="ticketDialog = true;")
      template(#left-icon)
        img.c-loop-icon(v-if="!isArena", src="@/assets/svg/plus.svg")
  arc-button#nohover(v-if="isArena", :name="$t('logout')", outline, style="border-color: #000;",
    @click="$root.logout()")

  spacer(size="50px")

  transition(name="taber" mode="out-in")
    router-view

  transition(name="fade" mode="out-in")
    input-dialog(v-if="ticketDialog", placeholder="Введите номер билета", @submit="callAssignTicket"
      @close="ticketDialog = false;")
      template(#title) {{$t('common.assignTicket')}}
      template(#button) {{$t('common.assign')}}
</template>

<script>
import { mapGetters } from 'vuex';
import API from '@/api/api';
import Order from '@/components/Order';
import Pagination from '@/components/Pagination';
import Skeleton from '@/components/Skeleton';

import NewOrder from '@/components/tickets/order';
import Empty from '@/components/tickets/empty';

export default {
  components: {
    Skeleton,
    Order,
    Pagination,
    Empty,
    NewOrder,
  },
  data: () => ({
    ticketDialog: false,
    active: 'all',
    orders: [],
    page: 1,
    lastPage: null,
    loading: true,
    moreButtons: [],
    isArena: false,
  }),
  watch: {
    isLogged() {
      this.getOrders();
    },
  },
  computed: {
    ...mapGetters({
      isLogged: 'user/isLogged',
    }),
  },
  mounted() {
    if (window.location.href.match(/minskarena/)) this.isArena = true;
    // this.getOrders();
  },
  methods: {
    doAction(oneButton) {
      console.log(oneButton);
    },
    callAssignTicket(code) {
      if (!code.length) {
        return;
      }
      API.assignTicket(code).then((response) => {
        const { code, message } = response;
        if (code && code === 400) {
          global.alert(message[0]);
          return;
        }
        this.getOrders();
        this.ticketDialog = false;
      }).catch((error) => {
        global.alert('Произошла ошибка сервера попробуйте позже!');
        global.console.error(error);
      }).finally(() => {});
    },
    assignTicket() {
      this.ticketDialog = true;
    },

    async getOrders() {
      this.loading = true;
      this.orders = [];
      const data = await API.getOrders({
        type: this.active,
        page: this.page,
      });
      if (data && data.data) {
        this.orders = data.data;
        this.lastPage = data.last_page;
        this.loading = false;
      } else {
        this.loading = false;
      }
    },
    changeType(type) {
      this.page = 1;
      this.active = type;
      this.getOrders();
    },
    toPage(page) {
      this.page = page;
      this.orders = [];
      this.getOrders();
    },
    toAfisha() {
      window.open('//24guru.by/afisha', '_top');
    },
  },
};
</script>

<style lang="scss">
  #nohover:hover {
    background-color: #fff !important;
  }
  #nohover {
    @media screen and (max-width: 60rem) {
      position: inherit !important;
      margin-top: unset !important;
    }
  }
  // .orders{
  //   border-bottom: 1px solid #ddd;
  // }
  // .no-orders{
  //   &__message{
  //     padding-bottom: 1rem;
  //     display: flex;
  //     .grey-ticket{
  //       width: 50px;
  //       height: 35px;
  //       background: url('../../../../common/assets/img/ticket_grey.png') no-repeat;
  //     }
  //     .label{
  //       color: #aaa;
  //       font-size: 13px;
  //       margin-top: .5rem;
  //     }
  //   }
  // }
  // .pag{
  //   display: flex;
  //   justify-content: center;
  //   padding-top: 1rem;
  // }
</style>
